import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Header from '../../components/Header';
import imgComplete from '../../assets/images/complete.svg';

const PreApproved = ({ navigate, checkinData }) => (
  <div className="transition-item wrapper v-center">
    <Header navigate={navigate} />
    <div className="content">
      <img src={imgComplete} alt="" />
      <h1>Thank You! Your loan is now complete and in progress to be funded</h1>
      <p>
        Hi
        {' '}
        {get(checkinData, 'state.data.firstName')}
        ! Your loan will be funded directly to your provider’s account on file within a few days.
      </p>
    </div>
  </div>
);

PreApproved.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(PreApproved);
